module.exports = __webpack_public_path__ + "static/media/Arch.5b528b9f.jpg";